import { useEffect, useState } from "react";
import { Case } from "generated/graphql";
import { Card, IconButton } from "@mui/material";
import { updateCaseSummary } from "redux/slices/case/";
import DebouncedTextarea from "components/DebouncedTextarea";
import { useAppDispatch } from "redux/hooks";
import LoadingSpinner from "components/LoadingSpinner";
import { CheckCircle, Close } from "@mui/icons-material";

function SavedState({ saved, loading }: { saved: boolean; loading: boolean }) {
  const [showSaved, setShowSaved] = useState<boolean>(false);

  useEffect(() => {
    if (saved) setShowSaved(true);
  }, [saved]);

  return loading ? (
    <LoadingSpinner size={20} />
  ) : showSaved ? (
    <div className="flex items-center">
      <CheckCircle className="mr-1 text-gray-200" />
      <p className="text-gray-400 text-xs">Case Summary Saved</p>
    </div>
  ) : (
    <></>
  );
}

const CaseSummary = ({ mycase, onClose }: { mycase: Case; onClose?: () => void }) => {
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [summary, setSummary] = useState<string>(mycase.summary || "");
  const dispatch = useAppDispatch();
  const saveSummaryChanges = async (summaryValue: string) => {
    setLoading(true);
    setSummary(summaryValue);
    await dispatch(updateCaseSummary({ caseId: mycase.id, summary: summaryValue })).unwrap();
    setLoading(false);
    setSaved(true);
  };

  return (
    <Card className="flex flex-col gap-2 p-4">
      {onClose && (
        <div className="flex justify-end">
          <IconButton size="small" onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      )}
      <div className="flex flex-col">
        <DebouncedTextarea
          minRows={1}
          maxRows={12}
          value={summary}
          textareaProps={{
            placeholder: "Write notes about the case...",
          }}
          onChange={saveSummaryChanges}
        />
      </div>
      <div className="flex justify-end pt-2">
        <SavedState loading={loading} saved={saved} />
      </div>
    </Card>
  );
};

export default CaseSummary;
